export let RoutingAction = /*#__PURE__*/function (RoutingAction) {
  /** Reroute - report via the target Sentry Hub */
  RoutingAction["REROUTE"] = "REROUTE";
  /** Don't reroute - report via the current Sentry Hub */
  RoutingAction["CONTINUE"] = "CONTINUE";
  /** Don't report to Sentry */
  RoutingAction["DROP"] = "DROP";
  return RoutingAction;
}({});
export let RoutingActionReason = /*#__PURE__*/function (RoutingActionReason) {
  /** Handled errors are never rerouted */
  RoutingActionReason["ERROR_IS_HANDLED"] = "ERROR_IS_HANDLED";
  /** Error originated from the current artifact */
  RoutingActionReason["HANDLER_MATCH"] = "HANDLER_MATCH";
  /** No artifact data was found in the stack-trace */
  RoutingActionReason["NO_ARTIFACTS_IN_STACKTRACE"] = "NO_ARTIFACTS_IN_STACKTRACE";
  /** There is artifact data in the stack-trace, but none of the artifacts has a matching Hub */
  RoutingActionReason["NO_REGISTERED_ARTIFACTS_IN_STACKTRACE"] = "NO_REGISTERED_ARTIFACTS_IN_STACKTRACE";
  /** At least one of the scripts in the stack-trace is blacklisted */
  RoutingActionReason["BLACKLISTED_SCRIPT_TYPE"] = "BLACKLISTED_SCRIPT_TYPE";
  /** There is a matching Hub for the first artifact in the stack-trace */
  RoutingActionReason["EXACT_REROUTE_MATCH"] = "EXACT_REROUTE_MATCH";
  /** There is no matching Hub for the first artifact in the stack-trace, and the current artifact is the first one to have a matching Hub   */
  RoutingActionReason["HANDLER_REROUTE_MATCH"] = "HANDLER_REROUTE_MATCH";
  /** There is no matching Hub for the first artifact in the stack-trace, but there is an artifact with a matching Hub down the stack-trace */
  RoutingActionReason["FALLBACK_REROUTE_MATCH"] = "FALLBACK_REROUTE_MATCH";
  return RoutingActionReason;
}({});
//# sourceMappingURL=sentry-plugin-types.js.map